/**
 * @generated SignedSource<<b528c0b9850c03d3c6fe9130512cb619>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TodoCategoryIcon = "Check" | "Message" | "Order" | "Sun";
export type TodoCategoryEditGeneralScreenMutation$variables = {
  icon: TodoCategoryIcon;
  id: string;
  title: string;
};
export type TodoCategoryEditGeneralScreenMutation$data = {
  readonly todoCategory: {
    readonly iconUpdate: {
      readonly id: string;
    };
    readonly titleUpdate: {
      readonly id: string;
    };
  } | null;
};
export type TodoCategoryEditGeneralScreenMutation = {
  response: TodoCategoryEditGeneralScreenMutation$data;
  variables: TodoCategoryEditGeneralScreenMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "icon"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "title"
},
v3 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }
],
v4 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "TodoCategoryMutation",
    "kind": "LinkedField",
    "name": "todoCategory",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "title",
            "variableName": "title"
          }
        ],
        "concreteType": "TodoCategory",
        "kind": "LinkedField",
        "name": "titleUpdate",
        "plural": false,
        "selections": (v3/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "icon",
            "variableName": "icon"
          }
        ],
        "concreteType": "TodoCategory",
        "kind": "LinkedField",
        "name": "iconUpdate",
        "plural": false,
        "selections": (v3/*: any*/),
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "TodoCategoryEditGeneralScreenMutation",
    "selections": (v4/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "TodoCategoryEditGeneralScreenMutation",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "62f4cad9fdd60ef8453e2408c842f3e9",
    "id": null,
    "metadata": {},
    "name": "TodoCategoryEditGeneralScreenMutation",
    "operationKind": "mutation",
    "text": "mutation TodoCategoryEditGeneralScreenMutation(\n  $id: ID!\n  $title: String!\n  $icon: TodoCategoryIcon!\n) {\n  todoCategory(id: $id) {\n    titleUpdate(title: $title) {\n      id\n    }\n    iconUpdate(icon: $icon) {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "9eadb885aa1d937492238905e777b6f3";

export default node;
